import React from 'react';
import { motion } from 'framer-motion';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function PainSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation(0.1);
  const painPoints = [{
    icon: '🖼️',
    text: 'Ponés el prompt y la imagen sale con errores de ortografía'
  }, {
    icon: '🔄',
    text: 'Le querés corregir algo y se te cambia toda la imagen'
  }, {
    icon: '⏳',
    text: 'Estás 3 horas para hacer UNA SOLA imagen'
  }, {
    icon: '📉',
    text: 'Tardás todo un día para hacer solo 5 creativos'
  }, {
    icon: '💸',
    text: 'Lanzás campañas y encima no venden'
  }];
  return <section className="py-20 md:py-32 bg-[#050505] relative overflow-hidden" data-id="element-204">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" data-id="element-205" />

      <div className="container mx-auto px-4 max-w-4xl" data-id="element-206">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 30
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-207">
          <h2 className="text-4xl md:text-6xl font-extrabold mb-6 tracking-tight text-white" data-id="element-208">
            ¿Vendés productos digitales?
          </h2>
          <p className="text-gray-400 text-xl md:text-2xl" data-id="element-209">
            Entonces seguro te pasa esto...
          </p>
        </motion.div>

        <div className="space-y-4 mb-16" data-id="element-210">
          {painPoints.map((point, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} animate={isVisible ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          delay: i * 0.15,
          duration: 0.5
        }} className="glass-card p-6 rounded-2xl flex items-center gap-6 hover:bg-white/[0.05] transition-colors" data-id="element-211">
              <div className="text-3xl md:text-4xl flex-shrink-0" data-id="element-212">
                {point.icon}
              </div>
              <p className="text-lg md:text-xl text-gray-300 font-medium" data-id="element-213">
                {point.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={isVisible ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        delay: 0.8,
        duration: 0.5
      }} className="glass-card border-l-4 border-l-red-500 p-8 md:p-10 rounded-2xl text-center bg-gradient-to-r from-red-900/10 to-transparent" data-id="element-214">
          <p className="text-xl md:text-2xl font-bold text-white" data-id="element-215">
            El problema no sos vos.{' '}
            <span className="text-red-400" data-id="element-216">
              El problema es que creativos mediocres no venden.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}